<div
  class="justify-content-between marquee--parent"
  [ngClass]="{ 'marquee--parent-ios': !!isIOS }">
  <div class="home--container marquee--container">
    <app-cigna-icon icon="lasted-news" class="size-32b mr-2"></app-cigna-icon>
    <div class="marquee--wrap justify-content-center flex">
      <div class="marquee--item" innerHTML="{{ text }}"></div>
      <div class="marquee--item" innerHTML="{{ text }}"></div>
    </div>
  </div>
</div>
